import type { Folder } from "~/types/folder"
import type { Subject } from "~/types/subject"
import { useQuery } from "@tanstack/vue-query"
import type { MaybeRefOrGetter } from "vue"

export interface MediaCounts {
  articles: number
  videos: number
  podcasts: number
  quizes: number
}

export function useMediaCounts(
  t: MaybeRefOrGetter<Folder | Subject | undefined>,
) {
  const api = useApiClients()

  return useQuery({
    queryKey: ["media-count", computed(() => toValue(t)?.id)] as const,
    enabled: computed(() => !!toValue(t)),
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
    async queryFn({ queryKey }) {
      const [, id] = queryKey

      return await api.ibexa<MediaCounts>(`/location/${id}/count`)
    },
  })
}
